import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=8c08991a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=8c08991a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c08991a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c08991a')) {
      api.createRecord('8c08991a', component.options)
    } else {
      api.reload('8c08991a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=8c08991a&scoped=true&", function () {
      api.rerender('8c08991a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21t6ySJ1Sh13S/JS/comp/Voucher.vue"
export default component.exports